import CasesPage from "./pages/CasesPage";
import InitialPage from "./pages/InitialPage";
import { useCases } from "./providers/Cases";
import { GlobalStyle } from "./styles/style";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  const { showCases } = useCases();
  return (
    <Router>
      <GlobalStyle />
      {showCases ? <CasesPage /> : <InitialPage />}
    </Router>
  );
}

export default App;
